export default __webpack_public_path__ + "static/media/Track_poscorad_1.cb259493.gif";